export default {"id":"58c19f1e","attrs":{"viewBox":"0 0 24 24","width":"24","height":"24"}}